import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class HierarchyService {

  private readonly hierarchyURL: string;


  constructor(private http: HttpClient) {
    this.hierarchyURL = '/api/hierarchy';
  }

  public getHierarchy(): any {
    return this.http.get<any>(this.hierarchyURL);
  }

  public getHierarchyDropdown(): any {
    const url: string = this.hierarchyURL + "/dropdown";
    return this.http.get<any>(url);
  }

  public getHierarchyTreeNodeFilter(hierarchy: any): any[] {
    let nodes: any[] = [];
    let hierarchyFilter: any[] = [];
    let organizationCodes: any[] = [];
    nodes[hierarchy.organizationUuid] = {
      expanded: true,
      label: (hierarchy.name + " (" + hierarchy.orgCode + ")"),
      data: hierarchy.organizationUuid,
      children: [],
      parent: null
    }; //ROOT element
    hierarchy.childs.forEach(child => {
      nodes[child.organizationUuid] = {
        label: (child.name + " (" + child.orgCode + ")"),
        data: child.organizationUuid,
        children: [],
        parent: null
      }
    });
    hierarchy.childs.forEach(child => {
      if (child.parentUuid !== null) {
        nodes[child.parentUuid].children.push(nodes[child.organizationUuid]);
      }
    });
    organizationCodes.push(nodes[hierarchy.organizationUuid]);
    hierarchy.childs.forEach(child => {
      organizationCodes.push(nodes[child.organizationUuid]);
    });
    hierarchyFilter.push(nodes[hierarchy.organizationUuid]); //ROOT element
    return [nodes, hierarchyFilter, organizationCodes];
  }

  public getHierarchyListTreeNode(hierarchyList: any): any[] {
    let nodes: any[] = [];
    let nodesFilter: any[] = [];
    let hierarchy: any[] = [];
    let hierarchyFilter: any[] = [];

    nodes[hierarchyList.organizationUuid] = {
      expanded: true,
      label: hierarchyList.name + " (" + hierarchyList.orgCode + ")",
      data:
        {
          organizationUuid: hierarchyList.organizationUuid,
          name: hierarchyList.name,
          orgCode: hierarchyList.orgCode,
          description: hierarchyList.description,
          organizationType: hierarchyList.organizationType,
          geocoding: hierarchyList.geocoding,
          totalMachines: hierarchyList.totalMachines,
          totalSqueezedFruits: hierarchyList.totalSqueezedFruits
        },
      children: []
    } //ROOT element
    nodesFilter[hierarchyList.organizationUuid] = {
      expanded: true,
      label: hierarchyList.name + " (" + hierarchyList.orgCode + ")",
      data: hierarchyList.organizationUuid,
      children: [],
      parent: null
    }; //ROOT element

    hierarchyList.childs.forEach(child => {
      nodes[child.organizationUuid] = {
        label: child.name + " (" + child.orgCode + ")",
        data: {
          organizationUuid: child.organizationUuid,
          name: child.name,
          orgCode: child.orgCode,
          description: child.description,
          organizationType: child.organizationType,
          geocoding: child.geocoding,
          parentUuid: child.parentUuid,
          totalMachines: child.totalMachines,
          totalSqueezedFruits: child.totalSqueezedFruits
        }, children: [], parent: null
      }
      nodesFilter[child.organizationUuid] = {
        label: child.name + " (" + child.orgCode + ")",
        data: child.organizationUuid,
        children: [],
        parent: null
      };
    });

    hierarchyList.childs.forEach(child => {
      if (child.parentUuid !== null) {
        nodes[child.parentUuid].children.push(nodes[child.organizationUuid]);
        nodesFilter[child.parentUuid].children.push(nodesFilter[child.organizationUuid]);
      }
    });
    hierarchy.push(nodes[hierarchyList.organizationUuid]); //ROOT element
    hierarchyFilter.push(nodesFilter[hierarchyList.organizationUuid]); //ROOT element
    return [nodes, hierarchy, hierarchyFilter];
  }

}
